<script setup lang="ts">
definePageMeta({
  whiteBackground: true,
  isPublic: true,
  layout: 'wide',
})

const route = useRoute()
const slug = route.params.slug as string
</script>

<template>
  <ContentPage :slug="slug" />
</template>
